import { API, IS_DEV } from '../../../shared/constants';
import { apiClient } from '../../../shared/lib/apiClient';
import { FEEDBACK_API } from '../feedback.constants';
import { Feedback, TelemetryEventCheck, UpdateFeedback } from '../feedback.types';

export const updateFeedbacks = async (
    id: number,
    body: UpdateFeedback,
): Promise<void> => {
    await apiClient.post(`${FEEDBACK_API.UPDATE_FEEDBACKS}?id=${id}`, body);
};

export const createTelemetryEvent = async (
    id: number,
    est: number | null,
): Promise<TelemetryEventCheck> => {
    const { data } = await apiClient.post<TelemetryEventCheck>(
        `${FEEDBACK_API.CREATE_TELEMETRY_EVENT}?id=${id}&est=${est}`,
    );
    return data;
};

export const updateTelemetryEvent = async (
    id: number,
    est: number | null,
    event: number | null,
): Promise<void> => {
    await apiClient.post(
        `${FEEDBACK_API.UPDATE_TELEMETRY_EVENT}?id=${id}&est=${est}&event=${event}`,
    );
};

export const getFeedbackDataRequest = async (
    vmId: number,
    orderInfo: { wallet_user_id: string | number; transaction_id: string | null; src?: number },
): Promise<Feedback> => {
    const url = IS_DEV
        ? '/dev/feedback_mock.json'
        : `${API.FEEDBACK_DATA}?vm=${vmId}`;
    const { data } = await apiClient.post<Feedback>(url, orderInfo);
    return data;
};
